<template>
    <div class="col registros-grid" v-if="idOcorrencia != 0 || idInstituicao != 0">
        <DataTable :id="id" :url_ajax="getUrlHistoricoRegistros()" :ajax_set_result="setHistorico" @grid_refreshed="gridRefreshed"
                   :refresh="refresh_grid" :filtros="filtro" method="GET" :qtd_registros_por_pagina="qtdRegistros" :is_table="true"
                   :footer_fixed="false" :headers="headersHistoricoRegistros" :pBtnsSlot="true" :is_NotLoading="NotLoading"
                   :customHeightPaginate="customHeightRegGrid" :customHeight="customHeightRegGridNoPage" :sizeWidBooton="customSizeWid" :request_api="'comercial'">
            <template v-slot:cell-slot="item">
                <div class="row mt-3 mb-3" :style="dinamicSize">
                    <div class="col-1 col-icon-registro">
                        <i v-if="item.row.tipo == 'Ligação'" class="fas fa-phone" style="color: #9F3029;" aria-hidden="true"></i>
                        <i v-if="item.row.tipo == 'Anotação'" class="fa fa-solid fa-file" style="color: #9F3029;" aria-hidden="true"></i>
                    </div>
                    <div class="col col-anotacao-registro pe-0">
                        <h3 class="h3-title-registro">{{ item.row.dtInclusao }} - {{ item.row.dsTipoAnotacao }} - {{ item.row.dsLoginInclusao }}</h3>
                        <div v-html="item.row.dsAnotacao"></div>
                    </div>
                    <div class="col-2 col-importante-registro" v-if="item.row.flImportante">
                        <span style="font-size:12px;"><i class="far fa-check-square"></i> Importante</span>
                    </div>
                    <div class="col-2 col-btn-registro ps-0" v-if="item.row.item != null">
                        <button type="button" v-if="item.row.tipo == 'Ligação'" :style="customBtnBaixar" class="btn-red btn-baixar" @click="getGravacao(item.row.item)">
                            <span class="">Baixar Gravação</span>
                        </button>
                        <button type="button" v-if="item.row.tipo == 'Anotação' && item.row.item != null && item.row.item != ''" class="btn-red btn-baixar" @click="getAnexo(item.row.idRegistro)">
                            <span class="">Baixar Anexo</span>
                        </button>
                    </div>
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script>

    import axios from 'axios';
    import DataTable from '@/components/App/Datatable.vue';
    import $ from 'jquery';

    export default {
        name: 'RegistrosGrid',
        components: {
            DataTable
        },
        props: {
            customBtnBaixar: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            idOcorrencia: {
                type: Number,
                default: 0
            },
            qtdRegistros: {
                type: Number,
                default: 20
            },
            idPessoa: {
                type: Number,
                default: 0
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
            idEvento: {
                type: Number,
                default: 0
            },
            reloadGrid: {
                type: Number,
                default: 0
            },
            filtroBusca: {
                type: String,
                default: ''
            },
            customHeightRegGrid: {
                type: String,
                default: ''
            },
            customHeightRegGridNoPage: {
                type: String,
                default: ''
            },
            customSizeWid: {
                type: String,
                default: ''
            },
            dinamicSize: {
                type: String,
                default: ''
            },
            cdTipoAnotacao: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                headersHistoricoRegistros: [
                    { class: '', name: '', text: 'Histórico de registros', actions: false, slot: true }
                ],
                filtro: [
                    { active: true },
                ],
                refresh_grid: false,
                NotLoading: false,
                index_table_count: 0
            }
        },
        methods: {

            gridRefreshed(data_ajax) {
                let $this = this;

                $this.index_table_count = 0;
                $this.refresh_grid = false;
                $this.NotLoading = false;
            },
            setHistorico(result) {
                return result;
            },
            getUrlHistoricoRegistros() {
                let $this = this;

                $this.index_table_count = 0;
                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetRegister?idOcorrencia=' + $this.idOcorrencia + '&idPessoa=' + $this.idPessoa + '&idInstituicao=' + $this.idInstituicao + '&idModulo=' + $this.idModulo + '&idEvento=' + $this.idEvento + '&cdTipoAnotacao=' + $this.cdTipoAnotacao;

            },
            getGravacao(value) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ligacao/GravacaoLigacao?uniqueId=' + value, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    window.open(response.data.data, "_blank");
                });
            },
            getAnexo(value) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Anotacao/GetDownloadAnexo?idAnotacao=' + value, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    window.open(response.data.data, "_blank");
                })
            },
        },
        mounted() { },
        watch: {
            idOcorrencia(newValue, oldValue) {
                if (newValue > 0) {
                    this.refresh_grid = true;
                }
            },
            idPessoa(newValue, oldValue) {
                if (newValue > 0) {
                    this.refresh_grid = true;
                }
            },
            reloadGrid(newVal, oldVal) {
                if (newVal > 0) {
                    this.refresh_grid = true;
                }
            },
            filtroBusca: function (newVal, oldVal) {
                let $this = this;

                $this.NotLoading = true;
                $this.filtro[0].value = newVal;
                $this.refresh_grid = true;
            },
        }
    }

</script>

<style scoped lang="scss">

    .col-icon-registro {
        max-width: 30px;
    }

    .col-btn-registro {
        max-width: 160px;
    }

    .col-anotacao-registro {
        line-height: 1;
    }

    .col-importante-registro {
        color: #FF7A00;
        font-weight: 550;
        max-width: 113px;
    }

    .h3-title-registro {
        font-size: 12px;
        font-weight: 550;
    }

    .btn-baixar {
        font-size: 12px;
        min-width: 130px;
    }
</style>